/* eslint-disable no-useless-escape */
import moment from 'moment';

export const EMAIL_PATTERN = new RegExp(
    /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@((?!(mailinator\.|hotmai\.|gmal\.|gmial\.|hotmialspamavert\.|trbvm\.|gotmail\.|sharklasers\.|trash-mail\.|evyush\.|vps911\.|0815\.|12hosting\.|usako\.|mailcatch\.|gamgling\.|lillemap\.|katztube\.|opayq\.|emil\.|gafy\.|cheaphub\.|12storage\.|hidebox\.|nokiamail\.|discard\.|tempr\.|discardmail\.|pecinan\.|spambog\.|mt2015\.|spambog\|drdrb\.|mvrht\.|freundin\.|sika3\.|anonymized\.|hartbot\.|tapi\.|digdig\.|mvrht\.|knol-power\.|neko2\.|zetmail\.|trbvn\.|grr\|disposable-email\.|usbc\.|20minutemail\.|macr2\.|dispostable\.|nwytg\.|nwytg\.|hulapla\.|harakirimail\.|eoopy\.|vfemail\.|f5\.|ahk\.|trashmail\.|21cn\.|disposable\.|tmail\.|fanclub\.|dayrep\.|apkmd\.|ruru\.|dropjar\.|jourrapide\.|hmamail\.|rsvhr\.|urhen\.|honeys\.|anonmails\.|e-mail\.|postonline\.|drdrb\.|20mail\.|forward\.|pfui\.|einrot\.|rhyta\.|freeletter\.|vssms\.|inboxstore\.|mbox\.|cachedot\.|inboxdesign\.|veanlo\.|zsero\.|cuoly\.|daabox\.|mailfs\.|20email\.|voltaer\.|teleworm\.|vomoto\.|boximail\.|tafmail\.|danwin1210\.|0815\.|cmail\.|maileme101\.|mnode\.|nutpa\.|xcodes\.|armyspy\.|magim\.|mailnesia\.|FREEONLINESEXCAMS\.|ONLINESEXCAMCHAT\.|LIVENUDEVIDEOCHAT\.|WATCHWEBCAMTHESEX\.|FREELIVESEXPORN\.|CAMSHOWSEX\.|SHOWCAMSEX\.|FREEONLINEWEBSEX\.|CAMERACHATSEX\.|FREELIVESEXONLINE\.|CAMSONLINESEX\.|FREECHATCAMSEX\.|SEXYCAMPORN\.|FREEWEBCAMSEXCHAT\.|BESTWEBCAMSEXSITE\.|FREESEXVIDEOCAM\.|BESTLIVESEXSITES\.|FREENUDEVIDEOCHAT\.|TOPFREECAMSITES\.|CAMSHOWPORN\.|WATCHLIVESEXCAM\.|CAMERAWEBSEX\.|FREEPRIVATESEXCAM\.|SEXCAMONLINEFREE\.|CHATLIVESEXY\.|WEBCAMNUDEFREE\.|FREEONLINEPORNCAM\.|CHATSEXYLIVE\.|FREEPORNCAMCHAT\.|BESTPORNCHAT\.|BESTFREELIVEPORN\.|WEBCAMSEXLIVEFREE\.|SEXYWEBCAMFREE\.|SEXYWEBCAMCHAT\.|ONLINELIVESEXCAM\.|FREELIVESEXYCAM\.|SEXCHATCAMERA\.|SEXCAMCOM\.|NAKEDLIVESEXCAM\.|LIVEWEBCAMSEXSHOW\.|SEXCAMERALIVE\.|LIVESEXYVIDEOCHAT\.|CHATSEXLIVECAM\.|SEXYCHATWEBCAM\.|MYDREAMSEX\.|FREEADULTSEXCAMS\.|SEX.DNS-CLOUD\.|XXXSEXCOM\.|WEBCAMSSEXLIVE\.|LIVECAMSEXSHOW\.|BESTSEXCAMLIVE\.|CHATLIVECAMSEX\.|SEXWEBCAMSHOW\.|CHARM-SEXYLINGERIE\.|BESTLIVESEXWEBCAM\.|FREESEXPORNWEBCAM\.|DIRTYDEEDSEXCAVATIONS\.)).*)\.((?!(CON|CIM|COMAU|VOM|AY|COME|CPM|COMM|COML|XOM|CLM|COMA|COMI|COOM|CCOM|COL|COMP|COMN|COK|COMS|COMJ|COMB|COMR|COMT|COMCOM|AH|COMQ|COMC|NETAU|CKM|COMD|TELSTRA|OCM|AUI|AUU|ON|COMK|COMG|COMO|COMU|CIN|CONM|FOM|COMH|COMF|AUJ|AJ|COMW|AUL|UL|CCM|COPM|AUM|AUS|AAU|AN|EDUAU|GOM|COLM|MAIL|AUA|UJ|DOM|COUK|LCOM|QU|COMV|COMY|COIM|DD|YOUR|COMTHE|AUP|NEY|MET|AIU|AUQ|GOVAU|DJDJDJ|AUY|NER|WA|AUT|COMZ|CVOM|CIOM|OOM|AUR|NSW|AUB|COMIN|FE|AUG|COMTO|CLOM|COMMA|AA|AUN|IK|CPOM|CMO|TE|NX|CAN|COMBA|COCM|EDI|AUC|AUE|UM|AOM)$).*)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})(:[0-9]{1,5})?$/i
);
export const EMAIL_PATTERN_FOR_ESIM = new RegExp(
    /^[-a-z0-9~!$%^&*_=}{\'?]+(\.[-a-z0-9~!$%^&*_=}{\'?]+)*@((?!(mailinator\.|hotmai\.|gmal\.|gmial\.|hotmialspamavert\.|trbvm\.|gotmail\.|sharklasers\.|trash-mail\.|evyush\.|vps911\.|0815\.|12hosting\.|usako\.|mailcatch\.|gamgling\.|lillemap\.|katztube\.|opayq\.|emil\.|gafy\.|cheaphub\.|12storage\.|hidebox\.|nokiamail\.|discard\.|tempr\.|discardmail\.|pecinan\.|spambog\.|mt2015\.|spambog\|drdrb\.|mvrht\.|freundin\.|sika3\.|anonymized\.|hartbot\.|tapi\.|digdig\.|mvrht\.|knol-power\.|neko2\.|zetmail\.|trbvn\.|grr\|disposable-email\.|usbc\.|20minutemail\.|macr2\.|dispostable\.|nwytg\.|nwytg\.|hulapla\.|harakirimail\.|eoopy\.|vfemail\.|f5\.|ahk\.|trashmail\.|21cn\.|disposable\.|tmail\.|fanclub\.|dayrep\.|apkmd\.|ruru\.|dropjar\.|jourrapide\.|hmamail\.|rsvhr\.|urhen\.|honeys\.|anonmails\.|e-mail\.|postonline\.|drdrb\.|20mail\.|forward\.|pfui\.|einrot\.|rhyta\.|freeletter\.|vssms\.|inboxstore\.|mbox\.|cachedot\.|inboxdesign\.|veanlo\.|zsero\.|cuoly\.|daabox\.|mailfs\.|20email\.|voltaer\.|teleworm\.|vomoto\.|boximail\.|tafmail\.|danwin1210\.|0815\.|cmail\.|maileme101\.|mnode\.|nutpa\.|xcodes\.|armyspy\.|magim\.|mailnesia\.|FREEONLINESEXCAMS\.|ONLINESEXCAMCHAT\.|LIVENUDEVIDEOCHAT\.|WATCHWEBCAMTHESEX\.|FREELIVESEXPORN\.|CAMSHOWSEX\.|SHOWCAMSEX\.|FREEONLINEWEBSEX\.|CAMERACHATSEX\.|FREELIVESEXONLINE\.|CAMSONLINESEX\.|FREECHATCAMSEX\.|SEXYCAMPORN\.|FREEWEBCAMSEXCHAT\.|BESTWEBCAMSEXSITE\.|FREESEXVIDEOCAM\.|BESTLIVESEXSITES\.|FREENUDEVIDEOCHAT\.|TOPFREECAMSITES\.|CAMSHOWPORN\.|WATCHLIVESEXCAM\.|CAMERAWEBSEX\.|FREEPRIVATESEXCAM\.|SEXCAMONLINEFREE\.|CHATLIVESEXY\.|WEBCAMNUDEFREE\.|FREEONLINEPORNCAM\.|CHATSEXYLIVE\.|FREEPORNCAMCHAT\.|BESTPORNCHAT\.|BESTFREELIVEPORN\.|WEBCAMSEXLIVEFREE\.|SEXYWEBCAMFREE\.|SEXYWEBCAMCHAT\.|ONLINELIVESEXCAM\.|FREELIVESEXYCAM\.|SEXCHATCAMERA\.|SEXCAMCOM\.|NAKEDLIVESEXCAM\.|LIVEWEBCAMSEXSHOW\.|SEXCAMERALIVE\.|LIVESEXYVIDEOCHAT\.|CHATSEXLIVECAM\.|SEXYCHATWEBCAM\.|MYDREAMSEX\.|FREEADULTSEXCAMS\.|SEX.DNS-CLOUD\.|XXXSEXCOM\.|WEBCAMSSEXLIVE\.|LIVECAMSEXSHOW\.|BESTSEXCAMLIVE\.|CHATLIVECAMSEX\.|SEXWEBCAMSHOW\.|CHARM-SEXYLINGERIE\.|BESTLIVESEXWEBCAM\.|FREESEXPORNWEBCAM\.|DIRTYDEEDSEXCAVATIONS\.)).*)\.((?!(CON|CIM|COMAU|VOM|AY|COME|CPM|COMM|COML|XOM|CLM|COMA|COMI|COOM|CCOM|COL|COMP|COMN|COK|COMS|COMJ|COMB|COMR|COMT|COMCOM|AH|COMQ|COMC|NETAU|CKM|COMD|TELSTRA|OCM|AUI|AUU|ON|COMK|COMG|COMO|COMU|CIN|CONM|FOM|COMH|COMF|AUJ|AJ|COMW|AUL|UL|CCM|COPM|AUM|AUS|AAU|AN|EDUAU|GOM|COLM|MAIL|AUA|UJ|DOM|COUK|LCOM|QU|COMV|COMY|COIM|DD|YOUR|COMTHE|AUP|NEY|MET|AIU|AUQ|GOVAU|DJDJDJ|AUY|NER|WA|AUT|COMZ|CVOM|CIOM|OOM|AUR|NSW|AUB|COMIN|FE|AUG|COMTO|CLOM|COMMA|AA|AUN|IK|CPOM|CMO|TE|NX|CAN|COMBA|COCM|EDI|AUC|AUE|UM|AOM)$).*)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})(:[0-9]{1,5})?$/i
);
export const SIM_SERIAL_NUMBER_PATTERN = new RegExp(/^(8(\d){12})$/);
export const SIM_SERVICE_PATTERN = new RegExp(/^(04(\d){8})$|^(8(\d){12})$/);
export const EXISTING_NUMBER_PATTERN = new RegExp(/^(04(\d){8})$/);
export const EXISTING_ACCOUNT_PATTERN = new RegExp(/^[a-zA-Z0-9]+$/i);
export const DRIVERS_LICENSE_PATTERN = new RegExp(/^[a-zA-Z0-9 ]{1,10}$/i);
export const BUSINESS_NAME_PATTERN = new RegExp(/^[a-zA-Z0-9\s!#$%&'()*,\-.\/\\_{}\|&quot;:;=?@]+$/);
export const TELSTRA_ID_PATTERN = new RegExp(/((^02|03|04|07|08)(?!@))/);
export const TELSTRA_ID_NUMBER_PATTERN = new RegExp(/^(02|03|04|07|08)[0-9]{8}$/);
export const TELSTRA_ID_EMAIL_PATTERN = new RegExp(/(@bigpond.com|@bigpond.net.au)$/i);
export const NUMBER_PATTERN = new RegExp(/^[0-9]*$/);
export const AUS_NUMBER = new RegExp(/^04[0-9]{8}$/);
export const ALPHANUMERIC_PATTERN = new RegExp(/^[0-9A-Za-z]*$/);
export const MIDDLE_NAME_PATTERN = new RegExp(/^[a-zA-Z\s'.-]{1,}$/);
// Regular expression to match Names for IDV. Names can contain ['.-] special characters.
export const IDV_NAMES_STRICT_PATTERN = new RegExp(/^[a-zA-Z\s]+([\'\.\-]?[a-zA-Z\s]*)+([\'\.\-]?[a-zA-Z\s]*)?$/);
export const IDV_NAMES_3_CONSECUTIVE_DUPLICATE_CHAR = new RegExp(/^(?!.*(.)\1\1)[a-zA-Z\s]+([\'\.\-]?[a-zA-Z\s]*)+([\'\.\-]?[a-zA-Z\s]*)?$/);
export const MEDICARE_CARD_STRICT_PATTERN = new RegExp(/^[a-zA-Z0-9\s\-']{1,}$/);
export const AUS_PASSPORT_STRICT_PATTERN = new RegExp(/^[a-zA-Z\s\-']{1,}$/);
export const INVALID_SEQEUNCE_PATTERN = new RegExp(/.*(--)+|(\.\.)+|(\.-)+|(-\.)+|(\.')+|('\.)+|('')+|(-')+|('-)+|(\s-)+|(-\s)+|('\s)+|(\s')+.*/);
export const INVALID_TOKEN_PATTERN = new RegExp(
    /(\sMRS\s)|(MRS\s)|(\sMS\s)|(MISS\s)|(MS\s)|(\sACN\s)|(ACN\s)|(\sABN\s)|(ABN\s)|(\sDOB\s)|(DOB\s)|(\sINc\s)|(INC\s)|(\sLTD\s)|(LTD\s)|(\sMR\s)|(MR\s)|(\sPL\s)|(PL\s)|(\sPTY\s)|(PTY\s)|(\sREP\s)|(REP\s)|(\sSP\s)|(SP\s)|(INCORPORATED)|(NO\sLIABILITY)|(PROPRIETARY)|(ON\sBEHALF)|(PASSWORD)|(XXX)/i
);
export const PASSWORD_PATTERN = new RegExp(/^(?=.*[a-z])(?=.*([A-Z]|[0-9]))[a-zA-Z_.-\d]{8,16}$/);
/* eslint-enable no-useless-escape */

export function isEmpty(value) {
    let valueIsEmpty = value === undefined || value === null || value === '';
    if (!valueIsEmpty && typeof value.trim === 'function') valueIsEmpty = value.trim() === '';
    return valueIsEmpty;
}

export function email(emailAddress, isEsimMode) {
    let domain = emailAddress.split('@');
    if (domain.length !== 2) {
        return true;
    }
    domain = domain[1];

    const names = domain.split('.');
    if (names.length < 2) {
        return true;
    }

    if (!isTopLevelDomainValid(names[names.length - 1])) {
        return true;
    }

    if (isEsimMode) {
        return !isEmpty(emailAddress) && !EMAIL_PATTERN_FOR_ESIM.test(emailAddress);
    }
    return !isEmpty(emailAddress) && !EMAIL_PATTERN.test(emailAddress);
}

export const isTopLevelDomainValid = (str) => {
    if (str.length < 2) {
        return false;
    }
    return str.match(/^[a-z]+$/i);
};

export const isEmailFormatValid = (emailAddress) => {
    const arr = emailAddress.split('@');
    if (arr.length !== 2) {
        return false;
    }

    const name = arr[0];
    const domain = arr[1];

    if (name.length === 0) {
        return false;
    }

    if (name.charAt(0) === '.' || name.charAt(name.length - 1) === '.') {
        return false;
    }

    if (domain.charAt(0) === '.') {
        return false;
    }

    const dnames = domain.split('.');
    if (dnames.length < 2) {
        return false;
    }

    if (!isTopLevelDomainValid(dnames[dnames.length - 1])) {
        return false;
    }

    return true;
};

export function validatePassword(password) {
    return !isEmpty(password) && !PASSWORD_PATTERN.test(password);
}

export function equalFields(value, matcher) {
    return !isEmpty(value) && !isEmpty(matcher) && value === matcher;
}

export function checkSimSerialPattern(simValue) {
    return !isEmpty(simValue) && !SIM_SERIAL_NUMBER_PATTERN.test(simValue);
}

export function checkSimPattern(simValue) {
    // TODO: Optimise the pattern based on simValue length
    return !isEmpty(simValue) && !SIM_SERVICE_PATTERN.test(simValue);
}

export function checkDlPattern(dlNumber) {
    return !isEmpty(dlNumber) && !DRIVERS_LICENSE_PATTERN.test(dlNumber);
}

export function validateBusinessName(companyName) {
    return !isEmpty(companyName) && BUSINESS_NAME_PATTERN.test(companyName);
}

// Below validation are lifed from old angular app
// TODO: Optimise the validations.
export function validateName(nameValue, allowNull = false) {
    if (allowNull && !nameValue) {
        return true;
    }
    if (nameValue == null) {
        return false;
    }
    if (nameValue.length > 1) {
        return IDV_NAMES_STRICT_PATTERN.test(nameValue);
    }
    return nameValue.length === 1 && nameValue[0].match('^[a-zA-Z]');
}

export function validateNameDuplicateChar(nameValue = '') {
    const validNamePattern = validateNamePattern(nameValue);
    if (nameValue.length > 1) {
        return IDV_NAMES_3_CONSECUTIVE_DUPLICATE_CHAR.test(nameValue) && validNamePattern;
    } else if (nameValue.length === 1) {
        return nameValue[0].match('^[a-zA-Z]');
    }
    return false;
}

export function validatePassport(passportNumber) {
    if (passportNumber === null) {
        return false;
    }
    const sanitizedPassportNumber = passportNumber.replace(/\s\s+/g, '');
    if (!sanitizedPassportNumber.match('^[a-zA-Z]{1,2}[0-9]{7}$')) {
        return false;
    }
    return true;
}

export function validateImmiCard(immiCardNumber) {
    if (immiCardNumber === null) {
        return false;
    }
    const sanitizedImmiCardNumber = immiCardNumber.replace(/\s\s+/g, '');
    if (!sanitizedImmiCardNumber.match('^[a-zA-Z]{3}[0-9]{6}$')) {
        return false;
    }
    return true;
}

export function validateInternationalPassport(passportNumber) {
    if (passportNumber === null) {
        // jshint ignore:line
        return false;
    }
    const sanitizedPassportNumber = passportNumber.replace(/\s\s+/g, '');
    if (!sanitizedPassportNumber.match('^[a-zA-Z0-9]{0,14}$')) {
        return false;
    }
    return true;
}

export function validateLicense(licenseNumber, stateSelected = '') {
    if (licenseNumber == null) {
        return false;
    }
    const sanitizedLicenseNumber = licenseNumber.replace(/\s/g, '');

    if (isEmpty(stateSelected)) {
        return false;
    }

    if (stateSelected === 'QLD') {
        // should contain only numbers
        if (sanitizedLicenseNumber.length > 9 || sanitizedLicenseNumber.length < 8 || !NUMBER_PATTERN.test(sanitizedLicenseNumber)) {
            return false;
        }
    }

    if (stateSelected === 'TAS' || stateSelected === 'NSW') {
        if (sanitizedLicenseNumber.length <= 8 && sanitizedLicenseNumber.length >= 6) {
            return !!ALPHANUMERIC_PATTERN.test(sanitizedLicenseNumber);
        }
        return false;
    }

    if (stateSelected === 'SA') {
        // should contain only numbers and alphabets
        if (sanitizedLicenseNumber.length !== 6 || !ALPHANUMERIC_PATTERN.test(sanitizedLicenseNumber)) {
            return false;
        }
    }

    if (stateSelected === 'ACT' || stateSelected === 'NT' || stateSelected === 'VIC') {
        // should contain only numbers
        if (!sanitizedLicenseNumber.match('^[0-9]{1,10}$')) {
            return false;
        }
    }

    if (stateSelected === 'WA') {
        // should contain only numbers
        if (sanitizedLicenseNumber.length !== 7 || !NUMBER_PATTERN.test(sanitizedLicenseNumber)) {
            return false;
        }
    }

    return true;
}

export function validateLicenseCardNumber(stateSelected, dlCardNumber) {
    if (stateSelected === 'QLD') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{10}$')) {
            return true;
        }
    } else if (stateSelected === 'TAS') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{9}$')) {
            return true;
        }
    } else if (stateSelected === 'NSW') {
        if (dlCardNumber.match('^[0-9]{10}$')) {
            return true;
        }
    } else if (stateSelected === 'SA') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{9}$')) {
            return true;
        }
    } else if (stateSelected === 'ACT') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{10}$')) {
            return true;
        }
    } else if (stateSelected === 'NT') {
        if (dlCardNumber.match('^[0-9]{6,8}$')) {
            return true;
        }
    } else if (stateSelected === 'VIC') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{8}$')) {
            return true;
        }
    } else if (stateSelected === 'WA') {
        if (dlCardNumber.match('^[a-zA-Z0-9]{8,10}$')) {
            return true;
        }
    }

    return false;
}

export function getDlCardNumberLength(stateSelected) {
    if (stateSelected === 'QLD') {
        return 10;
    } else if (stateSelected === 'TAS') {
        return 9;
    } else if (stateSelected === 'NSW') {
        return 10;
    } else if (stateSelected === 'SA') {
        return 9;
    } else if (stateSelected === 'ACT') {
        return 10;
    } else if (stateSelected === 'NT') {
        return 8;
    } else if (stateSelected === 'VIC') {
        return 8;
    } else if (stateSelected === 'WA') {
        return 10;
    }

    return 0;
}

export function validateMedicare(medicareNumber) {
    if (medicareNumber == null) {
        return false;
    }
    const sanitizedMedicareNumber = medicareNumber.replace(/\s\s+/g, '');
    if (!sanitizedMedicareNumber.match('^[0-9]{10}$')) {
        return false;
    }
    return true;
}

export function validateAcnNumber(acnNumber) {
    let isValid = !acnNumber || acnNumber.match('^[0-9]{9}$') !== null;
    if (acnNumber && isValid) {
        let totalDigitWeight = 0;
        let weightCounter = 8;
        for (let i = 0; i < acnNumber.length - 1; i += 1) {
            const digit = acnNumber.charAt(i);
            totalDigitWeight += digit * weightCounter;
            weightCounter -= 1;
        }
        let calculatedCheckDigit = 10 - (totalDigitWeight % 10); // prettier-ignore
        if (calculatedCheckDigit === 10) {
            calculatedCheckDigit = 0; // As Per ACN Formula If calculatedCheckDigit value is 10 then resetting to 0
        }
        isValid = calculatedCheckDigit === parseInt(acnNumber.charAt(acnNumber.length - 1), 10);
    }
    return isValid;
}

export function isValidAbnOrAcn(abnOrAcn) {
    return !!(abnOrAcn && abnOrAcn.toString().match(/^(\d{9}|\d{11})$/));
}

export function validateAbnNumber(abnNumber) {
    const isValid = !abnNumber || abnNumber.match('^[ 0-9]{11}$') !== null;
    let totalDigitWeight = 0;
    if (abnNumber && isValid) {
        const weightFactors = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        let weightCounter = 0;
        for (let x = 0; x < abnNumber.length; x += 1) {
            const digit = abnNumber.charAt(x);
            totalDigitWeight += (digit - (x === 0 ? 1 : 0)) * weightFactors[weightCounter];
            weightCounter += 1;
        }
    }
    return isValid && totalDigitWeight % 89 === 0;
}

export function validateNamePattern(nameValue) {
    const containsValidSequence = !INVALID_SEQEUNCE_PATTERN.test(nameValue);
    const containsValidToken = !INVALID_TOKEN_PATTERN.test(nameValue);
    return containsValidSequence && containsValidToken;
}

export function validateDay(dobDay) {
    if (dobDay == null || dobDay === '0' || dobDay === '00') {
        return false;
    }
    const sanitizeddobday = dobDay.replace(/\s\s+/g, '');
    if (!sanitizeddobday.match('^[0-9]{0,2}$')) {
        return false;
    }
    if (!isEmpty(dobDay) && (dobDay > 31 || dobDay < 1)) {
        return false;
    }
    return true;
}

export function validateDOB(dob) {
    const currentDate = moment();
    const formattedDate = moment(dob, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const minYears = '10';
    const maxYears = '120';
    const maxDate = currentDate.clone().subtract(minYears, 'years').format('YYYY-MM-DD');
    const minDate = currentDate.clone().subtract(maxYears, 'years').format('YYYY-MM-DD');
    if (!isEmpty(dob) && !moment(formattedDate).isBetween(minDate, maxDate, undefined, [])) {
        return false;
    }
    return true;
}

export function isMaximumYear(dob) {
    const currentDate = moment();
    const formattedDate = moment(dob, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const maxYears = '120';
    const minDate = currentDate.clone().subtract(maxYears, 'years').format('YYYY-MM-DD');
    if (!isEmpty(dob) && !moment(formattedDate).isSameOrBefore(minDate)) {
        return false;
    }
    return true;
}

export function validateExpireDate(expireDate, skipDay = false) {
    const currentDate = skipDay ? moment().format('YYYY-MM') : moment().format('YYYY-MM-DD');
    const timeData = skipDay ? moment(expireDate, 'MM/YYYY').format('YYYY-MM') : moment(expireDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const valid = skipDay ? moment(timeData).isAfter(currentDate) : moment(timeData).isSameOrAfter(currentDate);
    if (!isEmpty(expireDate) && !valid) {
        return false;
    }
    return true;
}

export function validateDate(dobDay, dobMonth, dobYear) {
    const oddMonths = ['0', '2', '4', '6', '7', '9', '11'];
    const evenMonths = ['3', '5', '8', '10'];
    if (oddMonths.includes(dobMonth)) {
        if (!isEmpty(dobDay) && (dobDay > 31 || dobDay < 1)) {
            return false;
        }
    } else if (evenMonths.includes(dobMonth)) {
        if (!isEmpty(dobDay) && (dobDay > 30 || dobDay < 1)) {
            return false;
        }
    } else if ((!(dobYear % 4) && dobYear % 100) || !(dobYear % 400)) {
        if (!isEmpty(dobDay) && (dobDay > 29 || dobDay < 1)) {
            return false;
        }
    } else if (!isEmpty(dobDay) && (dobDay > 28 || dobDay < 1)) {
        return false;
    }
    return true;
}

export function validateMiddlename(nameValue) {
    const name = nameValue.replace(/\s/g, '');
    return !isEmpty(name) && name.length >= 2 && MIDDLE_NAME_PATTERN.test(name);
}

export function validateMobileNumberPattern(mblNum) {
    return !isEmpty(mblNum) && !EXISTING_NUMBER_PATTERN.test(mblNum);
}

export function isValidBusinessPhoneNumber(str) {
    if (!isEmpty(str)) {
        const isAusNo = str.substring(0, 3);
        const isNo_13_18 = str.substring(0, 5);
        let pattern;
        if (isNo_13_18 === "+6113") {
            pattern = "^(\\+611)[3]([0-9]{4}|[0-9]{8})$"; //validation for 1300, either 9 or 13 digit length inclusive of +6113, Example- +611300xxxyy, +6113xxxy
        } else if (isNo_13_18 === "+6118") {
            pattern = "^(\\+611)[8][0-9]{8}$"; //validation for 1800, specific +6118 with 13 digit length, Example- +611800xxxyyy
        } else if (isAusNo === "+61") {
            pattern = "^(\\+61)[23478][0-9]{8}$"; //validation for 12 digit with specific +612,+613 etc
        } else {
            pattern = "^\\+[0-9]{5,20}$"; //validation for all other no except +61 starting range b/w 5 to 20.
        }
        const match = str.match(new RegExp(pattern));
        return !!match && match[0] === str;
    } else {
        return false;
    }
}